import {AppContext} from "./AppContext";
import {useContext, useState, useEffect} from "react";
import { Input } from "./Input";
import "./SyncPage.css";
import SyncStatus from "./SyncStatus";
import {useToast} from "@shopify/app-bridge-react";

export default function SyncPage(props) {
    let {
        cldStatus,
        getBackendUrl,
        postBackendUrl,
        backendUrl,
        setPoll,
        poll,
        setSyncStatus,
        shopifyState,
        stages,
    } = useContext(AppContext);
    const [folder, setFolder] = useState(null);
    const [disableFolder, setDisableFolder] = useState(false);
    const [config, setConfig] = useState({cname: 'https://res.cloudinary.com'})
    const {show} = useToast()

    useEffect(() => {
        async function getFolder() {
            let res = await getBackendUrl("sync/get-folder");
            if (res.ok) {
                if (res.folder !== "") {
                    setDisableFolder(true);
                }
                setFolder(res.folder);
            }
        }

        if (folder === null && cldStatus) {
            getFolder();
        }
    }, [setFolder, folder, getBackendUrl, setDisableFolder, cldStatus]);


    function validatedFolderPath(path) {
        const notAllowed = new RegExp('.*([\\\\?&#%<>+]).*', 'gm');
        let has = notAllowed.test(path)
        if (has) {
            show('The folder name should not contain the following characters ?&#\\%<>+', {error: true})
        } else {
        }
        return has
    }

    async function handleSyncOnClick() {
        const ret = await postBackendUrl("sync", {});
        if (ret && ret.ok) {
            if (ret.status === "working") {
                show("Sync is working")
                setPoll(true);
            } else if (ret.status === "nothingToDo") {
                show("No products to sync")
                setSyncStatus({status: ret.status, text: stages[ret.status]});
            } else {
                show("Error syncing products", {error: true})
            }
        } else {
            show("Error syncing " + ret.status, {error: true});
        }
    }

    async function handleFolderOnClick() {
            const ret = await postBackendUrl("sync/set-folder", {folder: folder});
            if (ret && ret.ok) {
                if (folder === "") {
                    setFolder('shopify')
                }
                setDisableFolder(true);

            } else {
                show("Error setting sync folder", {error: true})
            }
    }

    async function handleThemeUpdateOnClick() {
        const ret = await postBackendUrl("sync/update-theme");
        if (ret && ret.ok) {
            show("Cloudinary snippets updated")
        } else {
            show("Error updating theme files", {error: true});
        }
    }

    async function handleConfigOnClick() {
        const ret = await postBackendUrl("sync/update-config");
        if (ret && ret.ok) {
            if (ret.configuration) {
                if (ret.configuration.cname === 'none') {
                    ret.configuration.cname = config.cname
                }
                setConfig(ret.configuration)
            }
            show("Updated Config")
        } else {
            show(ret.message, {error: true})
        }
    }

    useEffect(() => {
        if (cldStatus) {
            handleConfigOnClick()
        }
    }, [cldStatus])

    useEffect(() => {
        if (shopifyState === false) {
            window.location.href = `${backendUrl}/auth${window.location.search}`
        }
    }, [shopifyState, backendUrl])

    return (
        <>
            {cldStatus && (
                <>
                    <h2 className={"header-title"}>Settings</h2>
                    <div className={"sync-page-wrap"}>
                        <div className={"info"}>
                            <h4 className={"title"}>Get Started</h4>
                            <p className={"text"}>
                                Start delivering product media from Cloudinary by following these steps.
                            </p>
                        </div>
                        <div className={"sync-wrap"}>
                            <div className={"component"}>
                                <div className={"step"}>
                                    <h4 className={"step-title"}>Step 1</h4>
                                    <p>Specify the folder path in your Cloudinary account to which you want to upload your product media from Shopify and click Start Media Upload. <a href={'https://cloudinary.com/documentation/shopify_user_guide#upload_your_shopify_product_media_to_cloudinary'} target={"_blank"} rel={"noopener noreferrer"}>More Info...</a></p>
                                </div>
                                <div className={"step"}>
                                    <h4 className={"step-title"}>Step 2</h4>
                                    <p>Edit your store’s theme code, using the Cloudinary snippets to deliver media from Cloudinary. <a href={"https://cloudinary.com/documentation/shopify_user_guide#display_images_and_videos_on_your_site"} target={"_blank"} rel={"noopener noreferrer"}>More Info...</a></p>
                                </div>
                                <div className={"step"}>
                                    <h4 className={"step-title"}>Step 3</h4>
                                    <p>Inspect your store’s media URLs in a browser to verify that images and videos are now optimized and being delivered from Cloudinary. <a href={"https://cloudinary.com/documentation/shopify_user_guide#verify_that_media_is_delivered_from_cloudinary"} target={"_blank"} rel={"noopener noreferrer"}>More Info...</a></p>
                                </div>
                            </div>

                        </div>

                    </div>
                    <div className={"sync-page-wrap"}>
                        <div className={"info"}>
                            <h4 className={"title"}>Sync to Cloudinary</h4>
                            <p className={"text"}>
                                Upload product media from your Shopify store to your{" "}
                                <a
                                    target={"_blank"}
                                    rel={"noreferrer"}
                                    href={"https://cloudinary.com"}
                                >
                                    Cloudinary account
                                </a>
                                .
                            </p>
                        </div>
                        <div className={"sync-wrap"}>
                            <div className="component">
                                <h4 className={"title"}>
                                    Upload Product Media From Shopify to Cloudinary
                                </h4>
                                <p className={"description"}>
                                    Sync your media to Cloudinary by uploading your media in
                                    Shopify to your Cloudinary account. Only product media that has
                                    changed since the last sync will be uploaded.
                                </p>
                                <div className={"folder-wrap"}>
                                    {!disableFolder && (
                                        <>
                                            <Input
                                                placeholder={"shopify"}
                                                label={"Folder path in Cloudinary"}
                                                setValue={setFolder}
                                                value={folder || ""}
                                                disabled={disableFolder}
                                                validate={validatedFolderPath}
                                            />
                                            <button
                                                className={"folder-path"}
                                                onClick={handleFolderOnClick}
                                            >
                                                Set Path
                                            </button>
                                            <div className={"input-desc"}>
                                                Media will be uploaded to this folder in your Cloudinary
                                                account.
                                            </div>
                                        </>
                                    )}
                                    {disableFolder && (
                                        <>
                                            <div className={"folder-label"}>
                                                Folder path in Cloudinary
                                            </div>
                                            <div className={"folder-path-disabled"}>{folder}</div>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className="component">
                                <button
                                    className={"sync"}
                                    disabled={poll || !disableFolder}
                                    onClick={handleSyncOnClick}
                                >
                                    Start Media Upload
                                </button>
                            </div>
                            <SyncStatus/>
                        </div>
                    </div>
                    <div className={"sync-page-wrap"}>
                        <div className={"info"}>
                            <h4 className={"title"}>Cloudinary Domain</h4>
                            <p className={"text"}>
                                Update the domain used for Cloudinary media URLs.
                            </p>
                        </div>
                        <div className={"sync-wrap"}>
                            <div className="component">
                                <h4 className={"title"}>
                                    Update Your Cloudinary Domain
                                </h4>
                                <p className={"description"}>
                                    The default Cloudinary domain is https://res.cloudinary.com. If you have requested a private CDN distribution or custom CNAME from Cloudinary, update this setting to your new domain.
                                </p>
                            </div>
                            <div className={"component"}>
                                <div className={"domain-label"}>Cloudinary Domain</div>
                                <div className={"domain"}>{config.cname}</div>
                                <button
                                    className={"folder-path"}
                                    onClick={handleConfigOnClick}
                                >
                                    Update Domain
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className={"sync-page-wrap"}>
                        <div className={"info"}>
                            <h4 className={"title"}>Cloudinary Snippets</h4>
                            <p className={"text"}>
                                Apply the latest Cloudinary snippets to your active theme.
                            </p>
                        </div>
                        <div className={"sync-wrap"}>
                            <div className="component">
                                <h4 className={"title"}>
                                    Update Active Theme
                                </h4>
                                <p className={"description"}>
                                    If you’ve changed your theme since installing the app you need to add the Cloudinary snippets to your active theme.
                                </p>
                            </div>
                            <div className={"component"}>
                                <div className={"theme-update"}>
                                    <button onClick={handleThemeUpdateOnClick}>Get Latest Snippets</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
}